<template>
  <!--<app-board :header="false" class="p-3 mb-3" id="voip-testing-panel">-->
  <el-tabs @tab-click="handleClick" type="border-card" v-if="amReady" v-model="selectedTab">
    <el-tab-pane :lazy="true" class="" label="Testing Tool" name="testingTool">
      <div v-if="routeTabName === 'testingTool'">
        <broadcast-form :allowDivisionChanging="false" :defaultDivision="defaultRouteDivision" :edit-mode="false"
                        :formHeader="false" formTitle=""></broadcast-form>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" class="p-2" label="All History" name="history-all">
      <div v-if="routeTabName === 'history-all'">
        <broadcast-history :edit-mode="false" :formHeader="false" :statusId="0" formTitle=""></broadcast-history>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" class="p-2" label="Awaiting Action" name="history-awaiting-action" v-if="!isUserCustomer">
      <span class="voip-call-test-status awaiting-action p-3" slot="label">Awaiting Action</span>
      <div v-if="routeTabName === 'history-awaiting-action'">
        <broadcast-history :edit-mode="false" :formHeader="false" :statusId="1" formTitle=""></broadcast-history>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" class="p-2" label="Info" name="testing-panel-info-tab">
      <span class="voip-call-test-status testing-panel-info-tab p-3" slot="label">Info</span>
      <div v-if="routeTabName === 'testing-panel-info-tab'">
        <info-tab></info-tab>
      </div>
    </el-tab-pane>


    <!--<el-tab-pane :lazy="true" class="p-2" label="Pending" name="history-pending" v-if="!isUserCustomer && !isUserMrt">
      <span class="voip-call-test-status pending p-3" slot="label">Pending</span>
      <div v-if="routeTabName === 'history-pending'">
        <broadcast-history :edit-mode="false" :formHeader="false" :statusId="6" formTitle=""></broadcast-history>
      </div>
    </el-tab-pane>-->

    <el-tab-pane :lazy="true" label="Unconnected" name="history-unconnected" v-if="!isUserCustomer">
      <span class="voip-call-test-status unconnected p-3" slot="label">Unconnected</span>
      <div v-if="routeTabName === 'history-unconnected'">
        <broadcast-history :edit-mode="false" :formHeader="false" :statusId="4" formTitle=""></broadcast-history>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" class="p-2" label="FAS" name="history-fas" v-if="!isUserCustomer">
      <span class="voip-call-test-status fas p-5" slot="label">FAS</span>
      <div v-if="routeTabName === 'history-fas'">
        <broadcast-history :edit-mode="false" :formHeader="false" :statusId="3" formTitle=""></broadcast-history>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" class="p-2" label="Working" name="history-working" v-if="!isUserCustomer">
      <span class="voip-call-test-status working p-3" slot="label">Working</span>
      <div v-if="routeTabName === 'history-working'">
        <broadcast-history :edit-mode="false" :formHeader="false" :statusId="2" formTitle=""></broadcast-history>
      </div>
    </el-tab-pane>


    <!--<el-tab-pane :lazy="true" class="p-2" label="Requires Test" name="history-requires-test" v-if="!isUserCustomer && !isUserMrt">
      <span class="voip-call-test-status requires-test p-3" slot="label">Required Test</span>
      <div v-if="routeTabName === 'history-requires-test'">
        <broadcast-history :edit-mode="false" :formHeader="false" :statusId="5" formTitle=""></broadcast-history>
      </div>
    </el-tab-pane>-->

    <!--
      <el-tab-pane :lazy="true" class="p-4" label="Testing Tool" name="testingTool">
        <div v-if="routeTabName === 'testingTool'">
          <broadcast-form :edit-mode="false" :formHeader="false" formTitle=""></broadcast-form>
        </div>
    </el-tab-pane>-->
  </el-tabs>

  <!--</app-board>-->
</template>
<script>
import {mapActions} from "vuex";
import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  mixins: [panelMixin],
  components: {
    broadcastForm: () => import('./../broadcast-form/View.vue'),
    broadcastHistory: () => import('./../broadcast-history/page/View.vue'),
    infoTab: () => import('./../info-tab/View.vue'),
    /* uploadDocumentRate: () => import('./../upload-document-rate/View.vue'),
     manualRate: () => import('./../manual-rate/View.vue'),
     viewRates: () => import('./../view-rates/View.vue')*/
  },
  beforeMount() {
    if (this.defaultRouteDivision) {
      this.panelMixin_getUserVoipDivision('divisionsList', () => {
        let r = this.divisionsList
        for (let d in r) {
          if (r[d].label == this.defaultRouteDivision) {
            this.defaultRouteDivision = r[d].value
          }
        }
        this.amReady = true
      })
    } else {
      this.amReady = true
    }
  },
  methods: {
    /*...mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),*/
    handleClick(tab, event) {
      let tabName = tab.$props.name
      let type = tabName.split('-');

      if (type[0] === 'history') {
        this.$router.push({
          name: 'module->voip-testing-panel->division->panel-tabs->tab->list->page', params: {
            division: this.$route.params.division,
            tabName: tabName,
            listPage: 1
          }
        })
      } else {
        this.$router.push({
          name: 'module->voip-testing-panel->division->panel-tabs->tab', params: {
            tabName: tabName,
            division: this.$route.params.division,
          }
        })
      }
    }
  },
  data() {
    return {
      defaultRouteDivision: this.$route.params.division,
      routeTabName: this.$route.params.tabName,
      tabPosition: 'top',
      selectedTab: this.$route.params.tabName,
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      isUserMrt: $store.getters['user-state/isUserMrt'],
      amReady: false,
    };
  }
};
</script>

<style>
/*#voip-testing-panel .el-tabs__nav .el-tabs__item {
  padding: 0 !important;
  margin: 0 10px !important;
}*/

/*#voip-testing-panel .el-tabs__nav .el-tabs__active-bar {
  background-color: rgba(100,100,100, .0) !important;
  border: 2px solid #444;
  height: 39px;
}*/
</style>
